<template>
  <div class="full-screen">

    <!-- qqqqqq -->
    <div
      class="overlay-card hidden 0000:0000 full-screen d-flex justify-center align-center"
    >
      <div class="d-flex flex-column justify-center align-center">
        <v-card
          flat
          width="80rem"
          class="text-center text-h3 font-weight-light pa-12"
        >
        qqqqqq
        </v-card>
        <div>
          <img
            src="imgs/features/qqqqqq.png"
            style="height: 40rem"
            outlined
          />
        </div>
      </div>
    </div>

    <!-- scroll -->
    <div
      class="overlay-card visible 0:10 full-screen d-flex justify-center align-center"
    >
      <span class="text-h3 font-weight-thin grey--text">
        Scroll to progress
      </span>
    </div>

    <!-- intro logo -->
    <div
      class="overlay-card hidden 20:300 full-screen d-flex justify-center align-center"
    >
      <div>
        <img
          src="imgs/logo/gs-logo-circle.png"
          style="width: 18rem; height: 18rem"
          class="soft-shadow"
        />
      </div>
      <div>
        <span
          class="text-h1 font-weight-bold"
          style="color: var(--color-asphalt)"
        >
          GreenShade
        </span>
        <p class="text-h2 font-weight-thin grey--text">
          Helping you upcycle your business
        </p>
      </div>
    </div>

    <!-- Get updated when the pools fill up. -->
    <div
      class="overlay-card hidden 300:600 full-screen d-flex justify-center align-center"
    >
      <div class="d-flex flex-column justify-center align-center">
        <v-card
          flat
          width="80rem"
          class="text-center text-h3 font-weight-light pa-12"
        >
        Get updated when the pools fill up.
        </v-card>
        <div>
          <img
            src="imgs/features/notify-service.png"
            style="height: 40rem"
            outlined
          />
        </div>
      </div>
    </div>

    <!-- qqqqqq -->
    <div
      class="overlay-card hidden 600:900 full-screen d-flex justify-center align-center"
    >
      <div class="d-flex flex-column justify-center align-center">
        <v-card
          flat
          width="80rem"
          class="text-center text-h3 font-weight-light pa-12"
        >
        qqqqqq
        </v-card>
        <div>
          <img
            src="imgs/features/qqqqqq.png"
            style="height: 40rem"
            outlined
          />
        </div>
      </div>
    </div>

    <!-- Automatically associates items with memorable graphics and icons which makes working with such data easeier. -->
    <div
      class="overlay-card hidden 900:1200 full-screen d-flex justify-center align-center"
    >
      <div class="d-flex flex-column justify-center align-center">
        <v-card
          flat
          width="80rem"
          class="text-center text-h3 font-weight-light pa-12"
        >
        Automatically associates items with memorable graphics and icons which makes working with such data easeier.
        </v-card>
        <div>
          <img
            src="imgs/features/item-icons.png"
            style="height: 40rem"
            outlined
          />
        </div>
      </div>
    </div>

    <!-- make smart suggestions -->
    <div
      class="overlay-card hidden 1200:1500 full-screen d-flex justify-center align-center"
    >
      <div class="d-flex flex-column justify-center align-center">
        <v-card
          flat
          width="80rem"
          class="text-center text-h3 font-weight-light pa-12"
        >
          GreenShade can look at extra columns on your board to make smart suggestions.
        </v-card>
        <div>
          <img
            src="imgs/features/03-info-pane_01.png"
            style="height: 40rem"
            outlined
          />
        </div>
      </div>
    </div>

    <!-- view of board-graph -->
    <div
      class="overlay-card hidden 1500:1800 full-screen d-flex justify-center align-center"
    >
      <div class="d-flex flex-column justify-center align-center">
        <v-card
          flat
          width="80rem"
          class="text-center text-h3 font-weight-light pa-12"
        >
        View of board-graph and resources that can be extracted from it.
        </v-card>
        <div>
          <img
            src="imgs/features/01-full-graph.png"
            style="height: 40rem"
            outlined
          />
        </div>
      </div>
    </div>

    <!-- Hover over items to get detailed view about them. -->
    <div
      class="overlay-card hidden 1800:2100 full-screen d-flex justify-center align-center"
    >
      <div class="d-flex flex-column justify-center align-center">
        <v-card
          flat
          width="80rem"
          class="text-center text-h3 font-weight-light pa-12"
        >
        Hover over items to get detailed view about them.
        </v-card>
        <div>
          <img
            src="imgs/features/01-full-graph_02.png"
            style="height: 40rem"
            outlined
          />
        </div>
      </div>
    </div>

    <!-- Drag and drop conversion possibilities. -->
    <div
      class="overlay-card hidden 2100:2400 full-screen d-flex justify-center align-center"
    >
      <div class="d-flex flex-column justify-center align-center">
        <v-card
          flat
          width="80rem"
          class="text-center text-h3 font-weight-light pa-12"
        >
        Drag and drop conversion possibilities.
        </v-card>
        <div>
          <img
            src="imgs/features/qqqqqq.png"
            style="height: 40rem"
            outlined
          />
        </div>
      </div>
    </div>

    <!-- See your inventory visualized as a graph with possible conversions (resources you can extract from it). -->
    <div
      class="overlay-card hidden 2400:2700 full-screen d-flex justify-center align-center"
    >
      <div class="d-flex flex-column justify-center align-center">
        <v-card
          flat
          width="80rem"
          class="text-center text-h3 font-weight-light pa-12"
        >
        See your inventory visualized as a graph with possible conversions (resources you can extract from it).
        </v-card>
        <div>
          <img
            src="imgs/features/06-info-pane_02.png"
            style="height: 40rem"
            outlined
          />
        </div>
      </div>
    </div>

    <!-- Manage conversions and get suggestions for possible conversions based on the item identification system.  -->
    <div
      class="overlay-card hidden 2700:3000 full-screen d-flex justify-center align-center"
    >
      <div class="d-flex flex-column justify-center align-center">
        <v-card
          flat
          width="80rem"
          class="text-center text-h3 font-weight-light pa-12"
        >
        Manage conversions and get suggestions for possible conversions based on the item identification system. 
        </v-card>
        <div>
          <img
            src="imgs/features/05-stats-menu_01.png"
            style="height: 40rem"
            outlined
          />
        </div>
      </div>
    </div>

    <!-- Use keyboard shortcuts to work quickly through big lists. -->
    <div
      class="overlay-card hidden 3000:3300 full-screen d-flex justify-center align-center"
    >
      <div class="d-flex flex-column justify-center align-center">
        <v-card
          flat
          width="80rem"
          class="text-center text-h3 font-weight-light pa-12"
        >
        Use keyboard shortcuts to work quickly through big lists.
        </v-card>
        <div>
          <img
            src="imgs/features/04-help-menu_01.png"
            style="height: 40rem"
            outlined
          />
        </div>
      </div>
    </div>

    <!-- Menu to help with managing what's in view. -->
    <div
      class="overlay-card hidden 3300:3600 full-screen d-flex justify-center align-center"
    >
      <div class="d-flex flex-column justify-center align-center">
        <v-card
          flat
          width="80rem"
          class="text-center text-h3 font-weight-light pa-12"
        >
        Menu to help with managing what's in view.
        </v-card>
        <div>
          <img
            src="imgs/features/02-speed-dial-menu_01.png"
            style="height: 40rem"
            outlined
          />
        </div>
      </div>
    </div>

    <!-- Set the date you plan to retire them. Stays in sync with your monday board. -->
    <div
      class="overlay-card hidden 3600:3900 full-screen d-flex justify-center align-center"
    >
      <div class="d-flex flex-column justify-center align-center">
        <v-card
          flat
          width="80rem"
          class="text-center text-h3 font-weight-light pa-12"
        >
        Set the date you plan to retire them. Stays in sync with your monday board.
        </v-card>
        <div>
          <img
            src="imgs/screenshots/monday-retire-date.png"
            style="height: 40rem"
            outlined
          />
        </div>
      </div>
    </div>

    <!-- Color system in sync with monday theme. -->
    <div
      class="overlay-card hidden 3900:4200 full-screen d-flex justify-center align-center"
    >
      <div class="d-flex flex-column justify-center align-center">
        <v-card
          flat
          width="80rem"
          class="text-center text-h3 font-weight-light pa-12"
        >
        Color system in sync with monday theme.
        </v-card>
        <div>
          <img
            src="imgs/features/material-colors.svg"
            style="height: 40rem"
            outlined
          />
        </div>
      </div>
    </div>

    <!-- Join multiple boards to see totals of how resources are pooling together. -->
    <div
      class="overlay-card hidden 4200:4500 full-screen d-flex justify-center align-center"
    >
      <div class="d-flex flex-column justify-center align-center">
        <v-card
          flat
          width="80rem"
          class="text-center text-h3 font-weight-light pa-12"
        >
        Join multiple boards to see totals of how resources are pooling together.
        </v-card>
        <div>
          <img
            src="imgs/features/07-dashboard-view.png"
            style="height: 40rem"
            outlined
          />
        </div>
      </div>
    </div>

    <!-- learn-more -->
    <div
      class="overlay-card hidden 4510:4800 full-screen d-flex flex-column justify-center align-center"
    >
      <v-card outlined>
        <p class="text-h4 font-weight-light font-style-italic">
          Full Walkthrough
        </p>
        <video preload autobuffer loop muted style="width: 20rem">
          <source type="video/mp4" src="vids/full-walkthrough.mp4" />
        </video>
      </v-card>
      <br /><br />
      <p class="text-h2 font-weight-thin grey--text">
        Learn more
      </p>
      <p class="text-h5 font-weight-thin grey--text">
        See all features, learn how to use and explore demos at links below
      </p>
      <p class="text-h5 font-weight-light">
        <a href="/demo-board" target="_blank" class="text-decoration-none blue--text">
          green-shade.web.app/demo-board
        </a>
      </p>
      <p class="text-h5 font-weight-light">
        <a href="/demo-dashboard" target="_blank" class="text-decoration-none blue--text">
          green-shade.web.app/demo-dashboard
        </a>
      </p>
      <p class="text-h5 font-weight-light">
        <a href="/explore" target="_blank" class="text-decoration-none blue--text">
          green-shade.web.app/explore
        </a>
      </p>
      <p class="text-h5 font-weight-light">
        <a href="/features" target="_blank" class="text-decoration-none blue--text">
          green-shade.web.app/features
        </a>
      </p>
      <p class="text-h5 font-weight-light">
        <a href="https://github.com/amitlzkpa/green-shade" target="_blank" class="text-decoration-none blue--text">
          github.com/amitlzkpa/green-shade
        </a>
      </p>
    </div>

    <!-- try it out -->
    <div
      class="overlay-card hidden 4800:5000 full-screen d-flex flex-column justify-center align-center"
    >
      <div>
        <img
          src="imgs/logo/gs-logo-circle.png"
          style="width: 9rem; height: 9rem"
          class="soft-shadow"
        />
      </div>
      <p
        class="text-h1 font-weight-bold"
        style="color: var(--color-asphalt)"
      >
        GreenShade
      </p>
      <br /><br />
      <p class="text-h4 font-weight-thin grey--text">
        Try it out
      </p>
      <p class="text-h2 font-weight-thin">
        <a href="/" class="text-decoration-none blue--text">
          green-shade.web.app
        </a>
      </p>
    </div>
  </div>
</template>

<script>

// -- videos deps:[timestamps]

// pauses video if computed style has visibility !== hidden
function setupVidPlayPauser() {
  let videos = document.getElementsByTagName("video");
  window.addEventListener("wheel", () => {
    for (let i = 0; i < videos.length; i++) {
      let video = videos[i];
      let shouldPause = window.getComputedStyle(video).visibility === "hidden";
      if (shouldPause) {
        video.pause();
      } else {
        video.play();
      }
    }
  });
  
}

// -- timestamps

let maxVal = 4000;
let startVal = 0;
let moveSpeed = 10;
let currentVal = startVal;

let scaleMoveAmt = 1;
let scaleTime = 1;
scaleTime = 0.5;

let moveAmt;

function updateCardStates() {
  let overlayCards = document.querySelectorAll("[class*=overlay-card]");
  overlayCards.forEach((node) => {
    let timeStamp = [...node.classList].filter((cl) => cl.includes(":"))[0];
    let isSkipped = node.classList.contains("skip");
    if (!timeStamp) return;
    let stVal = timeStamp.split(":")[0] * scaleTime;
    let edVal = timeStamp.split(":")[1] * scaleTime;
    let isInTimeWindow = stVal <= currentVal && currentVal < edVal;
    if (isInTimeWindow && !isSkipped) {
      node.classList.add("visible");
      node.classList.remove("hidden");
    } else {
      node.classList.remove("visible");
      node.classList.add("hidden");
    }
  });
}

function setupScrollReader() {

window.addEventListener("keydown", (event) => {
  if (event.key !== "ArrowDown") return;
  moveAmt = moveSpeed * scaleMoveAmt * 3;
  if (currentVal + moveAmt <= 0) {
    currentVal = 0;
    moveAmt = 0;
  } else if (currentVal + moveAmt >= maxVal) {
    currentVal = maxVal;
    moveAmt = 0;
  } else {
    currentVal += moveAmt;
  }

  // console.log(`${moveAmt}\t\t${currentVal}`);

  updateCardStates();
});

  window.addEventListener("keydown", (event) => {
    if (event.key !== "ArrowUp") return;
    moveAmt = moveSpeed * scaleMoveAmt * 3 * -1;
    if (currentVal + moveAmt <= 0) {
      currentVal = 0;
      moveAmt = 0;
    } else if (currentVal + moveAmt >= maxVal) {
      currentVal = maxVal;
      moveAmt = 0;
    } else {
      currentVal += moveAmt;
    }

    // console.log(`${moveAmt}\t\t${currentVal}`);

    updateCardStates();
  });

  window.addEventListener("wheel", (event) => {
    moveAmt = moveSpeed * (event.deltaY < 0 ? -1 : 1) * scaleMoveAmt;
    if (currentVal + moveAmt <= 0) {
      currentVal = 0;
      moveAmt = 0;
    } else if (currentVal + moveAmt >= maxVal) {
      currentVal = maxVal;
      moveAmt = 0;
    } else {
      currentVal += moveAmt;
    }

    // console.log(`${moveAmt}\t\t${currentVal}`);

    updateCardStates();
  });
}

export default {
  async mounted() {
    setupScrollReader();
    setupVidPlayPauser();
  },
};
</script>

<style scoped>

.overlay-card {
  z-index: 9999;
  position: fixed;
}

</style>